import { Flex } from '@approvalmax/ui/src/components';
import { useQbooksVerifyEmailPopup } from 'app/(auth)/oauth2/redirect/resources/hooks/useQbooksVerifyEmailPopup';
import { memo } from 'react';

import { ToggleLoginRegister } from '../../../../resources/components';
import { LoginForm } from '../LoginForm/LoginForm';

export const LoginModule = memo(() => {
    useQbooksVerifyEmailPopup();

    return (
        <Flex direction='column' spacing='40'>
            <ToggleLoginRegister />

            <LoginForm />
        </Flex>
    );
});

LoginModule.displayName = 'LoginModule';
